/** Matches API CatalogLimit::PREVIEW_DEFAULT — use for dashboard catalog fetches. */
export const DASHBOARD_CATALOG_LIMIT = 50;
